<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M3.527 3.527A1.8 1.8 0 014.8 3H8a1 1 0 110 2H5v3a1 1 0 11-2 0V4.8c0-.477.19-.935.527-1.273zM12.333 4a1 1 0 011-1h5.334a1 1 0 110 2h-5.334a1 1 0 01-1-1zM23 4a1 1 0 011-1h3.2A1.8 1.8 0 0129 4.8V8a1 1 0 11-2 0V5h-3a1 1 0 01-1-1zM4 12.333a1 1 0 011 1v3h8.867a1.8 1.8 0 011.8 1.8V27h3a1 1 0 110 2H4.8A1.8 1.8 0 013 27.2V13.333a1 1 0 011-1zM13.667 27v-8.667H5V27h8.667zm0-13.667a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 11-2 0v-3h-3a1 1 0 01-1-1zm14.333-1a1 1 0 011 1v5.334a1 1 0 11-2 0v-5.334a1 1 0 011-1zM28 23a1 1 0 011 1v3.2a1.8 1.8 0 01-1.8 1.8H24a1 1 0 110-2h3v-3a1 1 0 011-1z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'webSystemScaleOutline'
}
</script>
